import { createContext, useContext, useState } from "react";

const DataModeContext = createContext({ mode: "live", setMode: () => {} });

export const DataModeProvider = ({ children }) => {
  const [mode, setMode] = useState("live");
  return <DataModeContext.Provider value={{ mode, setMode }}>{children}</DataModeContext.Provider>;
};

export const useDataMode = () => useContext(DataModeContext);
